// Helpers "visas en retard" (écran 028).
//
// Le picto "en retard" est porté par la version diffusée la plus fraîche du
// document : l'API ne renseigne `lateAvisTeamIds` que sur celle-ci. Le filtre
// "Documents diffusés à" restreint les destinataires pris en compte pour le
// picto, et estompe les versions non diffusées à la sélection.

import type { DocumentData, VersionData } from "./types";

/**
 * True when the document has at least one destinataire with an overdue
 * required avis, restricted to `selectedTeamIds` when the "Documents diffusés
 * à" filter is active (empty selection = all destinataires).
 */
export function isDocumentVisaEnRetard(
  doc: DocumentData,
  selectedTeamIds: number[],
): boolean {
  return doc.versions.some((v) => isVersionVisaEnRetard(v, selectedTeamIds));
}

/** Same rule for one version: the one row of the table carrying the picto. */
export function isVersionVisaEnRetard(
  version: VersionData,
  selectedTeamIds: number[],
): boolean {
  const lateTeamIds = version.lateAvisTeamIds ?? [];
  return selectedTeamIds.length === 0
    ? lateTeamIds.length > 0
    : lateTeamIds.some((id) => selectedTeamIds.includes(id));
}

/**
 * True when the version must be visually faded because it was not diffused to
 * any of the selected destinataires. No fading when the filter is inactive.
 */
export function isVersionEstompee(
  version: VersionData,
  selectedTeamIds: number[],
): boolean {
  if (selectedTeamIds.length === 0) return false;
  return !(version.diffusedTeamIds ?? []).some((id) =>
    selectedTeamIds.includes(id),
  );
}
